<div fxLayout="row" fxLayoutWrap="wrap" class="user-profile" style="background: url(assets/images/imageUser.png) no-repeat;background-size:240px;">
  <!-- <div class="profile-img">
    <img *ngIf="currentUser && currentUser.photoBase64" [src]="'data:image;base64,' + currentUser.photoBase64 | imagePipe" alt="user">
  </div> -->
  <div class="profile-text">
    <span>{{currentUser.lastName + ', ' + currentUser.firstName}}</span>
  </div>
</div>
<mat-nav-list appAccordion>
  <mat-list-item appAccordionLink *ngFor="let menuitem of itemSidebar" routerLinkActive="selected"
    group="{{menuitem.state}}">
    <a class="" appAccordionToggle [routerLink]="['/', menuitem.state]"
      *ngIf="menuitem.type === 'link' && menuitem.state != 'logout' && menuitem.state != 'configuration'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name }}</span>
      <span fxFlex></span>
      <span class="label label-{{ badge.type }} " *ngFor="let badge of menuitem.badge ">{{ badge.value }}</span>
    </a>
    <a class="" appAccordionToggle [routerLink]="['/pages/', menuitem.state]"
      *ngIf="menuitem.type === 'link' && menuitem.state == 'logout'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name }}</span>
      <span fxFlex></span>
      <span class="label label-{{ badge.type }} " *ngFor="let badge of menuitem.badge ">{{ badge.value }}</span>
    </a>
    <a class="" appAccordionToggle [matMenuTriggerFor]="configuration"
      *ngIf="menuitem.type === 'link' && menuitem.state == 'configuration'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name }}</span>
    </a>
    <mat-menu #configuration="matMenu" class="mymegamenu" yPosition="below" xPosition="after">
      <button mat-menu-item (click)="goTo(badge.state)" *ngFor="let badge of menuitem.badge">
        <mat-icon>{{ badge.icon }}</mat-icon>
        <span>{{badge.name}}</span>
      </button>
    </mat-menu>
  </mat-list-item>
</mat-nav-list>